"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiPickers = void 0;
var palette_1 = require("../../global/palette");
var typography_1 = require("../../global/typography");
var shape_1 = require("../../global/shape");
exports.MuiPickers = {
    MuiPickersDay: {
        day: __assign(__assign(__assign({}, typography_1.typography.body1), shape_1.shape), { height: 32, width: 39, margin: 2, '& .MuiTypography-root': {
                fontSize: 16,
            }, '&:hover': {
                backgroundColor: palette_1.palette.grey[300],
                color: palette_1.palette.common.black,
            }, '&:active': {
                backgroundColor: palette_1.palette.primary.main,
                color: palette_1.palette.common.white,
            } }),
        current: {
            backgroundColor: palette_1.palette.info.main,
            color: palette_1.palette.common.white,
        },
        daySelected: {
            backgroundColor: palette_1.palette.primary.main,
            '&:hover': {
                backgroundColor: palette_1.palette.grey[300],
                color: palette_1.palette.common.black,
            },
        },
    },
    MuiPickersCalendarHeader: {
        dayLabel: __assign(__assign({}, typography_1.typography.body1), { color: palette_1.palette.grey[500] }),
        transitionContainer: {
            '& .MuiTypography-root': __assign(__assign({}, typography_1.typography.subtitle1), { textTransform: 'capitalize' }),
        },
    },
    MuiPickersClock: {
        clock: {
            '& .MuiTypography-body2': {
                fontSize: '0.875rem',
                color: palette_1.palette.primary.light,
                '&:hover': {
                    backgroundColor: palette_1.palette.primary.main,
                    color: palette_1.palette.common.white,
                },
            },
            '& .MuiTypography-body1': {
                fontSize: '1.125rem',
            },
            '& .MuiPickersClockPointer-pointer': {
                backgroundColor: palette_1.palette.primary.light,
                '& .MuiPickersClockPointer-thumb': {
                    borderColor: palette_1.palette.primary.light,
                    backgroundColor: palette_1.palette.primary.light,
                    border: 'solid 14px',
                },
                '& .MuiPickersClockPointer-noPoint': {
                    backgroundColor: palette_1.palette.primary.light,
                },
            },
            '& .MuiPickersClock-pin': {
                backgroundColor: palette_1.palette.primary.light,
            },
            '& .MuiPickersClockNumber-clockNumberSelected': {
                color: palette_1.palette.common.white,
            },
        },
    },
};
